/**
 * Checks to make sure that the current date is contained within the bounds
 * given as parameters, `startDate` and `endDate`. If `startDate` is null,
 * then the only check is that the current date is before the `endDate`
 * @param {Object} options
 * @param {string} [options.startDate] - any value that the `Date` constructor accepts, optional
 * @param {string} options.endDate - any value that the `Date` constructor accepts
 */
export function isValidBoundedDate({ startDate, endDate }) {
    const isStarted = startDate ? new Date().getTime() > new Date(startDate).getTime() : true;
    const isEnded = new Date().getTime() > new Date(endDate).getTime();
    return isStarted && !isEnded;
}
